module.exports = __webpack_public_path__ + "img/gbsinbo_04.c3b4508c.png";